{
  "menu": {
    "login": "Log in",
    "logout": "Log out",
    "support": "Support"
  },
  "applicationSummary": {
    "companyNameLabel": "Company",
    "change": "Change application"
  },
  "applicationSelector": {
    "choose": "Choose",
    "cancel": "Cancel"
  },
  "login": {
    "identificationSuccessful": "You have been identified"
  },
  "eligibilityCheckForm": {
    "heading": "Check if you are eligible",
    "checkYourEligibility": "Check your eligibility",
    "checkYourEligibilityWithoutCreditCheck": "Check your eligibility - without UC"
  },
  "preliminaryBidForm": {
    "preliminaryBidHeading": "Estimate your credit limit",
    "estimateLimitWithoutCreditCheck": "Estimate limit - without credit check",
    "estimateLimit": "Estimate limit",
    "loadingText": "Calculating how much you can get in a loan...",
    "loadingTextEligibilityCheck": "Calculating your eligibility to receive a loan...",
    "weEstimateThatCompanyCanReceive": "We estimate that {{organisationName}} can receive ",
    "immediateResponse": "Immediate response",
    "immediateResponseWithoutCreditCheck": "Immediate response, without credit check"
  },
  "delegatedInformationPage": {
    "heading": "You have been invited to add information",
    "description": "has asked you to add information in connection with an application for financing for the company"
  }
}
